export const Footer = () => {

    return (
        <div class="w-full text-center py-8 bg-black text-gray-300">
            Website by Caleb Lee and Matthew Xu
        </div>
    );
}